import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import {Row, Col, Alert, Modal} from 'react-bootstrap';
import Loader from '../../../../Loader';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import { CONFIG } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';

import KelasSearch from '../../../../../entity/KelasSearch';
import KelasParalelSearch from '../../../../../entity/KelasParalelSearch';
import DropdownTahunAjaran from '../../masterDropDown/DropdownTahunAjaran';
import DropdownKelas from '../../masterDropDown/DropdownKelas';
import DropdownKelasParalel from '../../masterDropDown/DropdownKelasParalel';


class KecakapanUmum extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isLoading : false,
            kodeJenjangSekolah : null,
            ta: [],
            kelas: [],
            kelasParalel: [],
            jadwalCbt: [],
            listSiswa: [],
            kodeTahunAjaran: null,
            idKelas: null,
            idJadwal: null
        }
    }

    componentDidMount(){
        console.clear();
        console.log('IKI PROPS')
        console.log(this.props)
        if(!__.isEmpty(this.props.data.ta)){
            this.setState({ 
                ta : this.props.data.ta,
                kelas : this.props.data.kelas,
                kodeTahunAjaran : this.props.data.kodeTa,
                // idKelas : this.props.data.kuota.idKelas,
                jadwalCbt : this.props.data.jadwalCbt
            });
        }
    }

    handleOnChange = async (e) =>{
        let name = e.target.name;
        let val = e.target.value;
        this.setState({ [name]:val });


        // cari profil PEMINATAN
        if(name === 'idKelas'){
            this.setState({isLoading: true, kelasParalel:[], idKelasParalel:'', jadwalCbt:[], idJadwal:''});
            const resKelasParalel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL, 
                {KelasParalelSearch,['idKelas']: val, ['idSekolah']: this.props.account.idSekolah}).catch (function(error){
            })  
    
            // masukan kelas paralel ke  dropdown
            if(resKelasParalel){
                if(resKelasParalel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        kelasParalel: resKelasParalel.data.data
                    })
                }
            }
            this.setState({isLoading: false});
        }

        if(name === 'idKelasParalel'){
            this.setState({isLoading: true, jadwalCbt:[], idJadwal:''});
            const response = await accountManagement.get(CONFIG.REPORT_CBT_GET_JADWAL, {
                params: { 
                    tahunAjaran: this.state.kodeTahunAjaran, 
                    idSekolah: this.props.account.idSekolah,
                    idKelas: this.state.idKelas,
                    tipeCbt: 'PEMINATAN'
                }
            }).catch (function(error){ console.log(error)}) 
    
            if(response) {
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        idJadwal:'',
                        jadwalCbt: response.data.data 
                    })
                }
            }
            this.setState({isLoading: false});
        }

        if(name === 'idJadwal'){
            this.setState({isLoading: true, listSiswa:[]});
            const response = await accountManagement.get(CONFIG.REPORT_CBT_LIST_SISWA, {
                params: { 
                    tahunAjaran: this.state.kodeTahunAjaran, 
                    idJadwalCbt: val,
                    idKelasParalel: this.state.idKelasParalel,
                    idKelas: this.state.idKelas,
                    idSekolah: this.props.account.idSekolah
                }
            }).catch (function(error){ console.log(error)}) 
    
            if(response) {
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        listSiswa: response.data.data
                    })
                }
            }
            this.setState({isLoading: false});
        }
    }

    renderSiswa() {
        return(
            <table className="table table-stripped">
                <thead>
                    <th width='5%'>No.</th>
                    <th>Nama Siswa</th>
                    {/* <th className="text-center" width='20%'>Agcu Akademik</th>
                    <th className="text-center" width='20%'>Agcu Non Akademik</th> */}
                <th className="text-center" width='20%'>Report Siswa</th>
                </thead>
                <tbody>
                    {this.state.listSiswa.map((data,i) => 
                    <tr key={i}>
                        <td>{i+1}</td>
                        <td>{data.namaSiswa}</td>
                        {/* <td className="text-center">
                            <button className="btn btn-outline-info" title="Detail Pengerjaan TEST Akademik" onClick={() => this.handleModal(data.idHeaderHasilCbt, 'akademik')}>
                                <li className="fa fa-info"></li>
                            </button>
                        </td>
                        <td className="text-center">
                            <button className="btn btn-outline-success" title="Detail Pengerjaan TEST NON Akademik" onClick={() => this.handleModal(data.idHeaderHasilCbt, 'non')}>
                                <li className="fa fa-info"></li>
                            </button>
                        </td> */}
                        <td className="text-center">
                            {data.statusPengerjaan === data.jumlahSubTest && data.statusAgcu === "9" ? 
                            <a className="btn btn-info" title="Detail report siswa" href={'rptku/'+
                                                                                            (this.props.account.idSekolah * data.idHeaderHasilCbt)+"/"+
                                                                                            (this.props.account.idSekolah * this.state.idJadwal)+"/"+
                                                                                            (this.props.account.idSekolah * data.idSiswa)
                                                                                        } target="_blank">
                                <li className="fa fa-print"></li>                                                                                                
                            </a>        
                            
                            : 
                            <button className="btn btn-danger" title="Belum Mengerjakan sama sekali" aria-hidden="true">
                                <li className="fa fa-eye-slash">

                                </li>
                            </button>}
                        </td>
                    </tr>
                    )}                 
                </tbody>
            </table>                   
        )
    }

    componentDidUpdate(){
        console.clear();
        console.log(this.state);
    }


    render() { 
        const {jurusan, kodeJenjangSekolah, isReport, isReportSiswa, jadwalCbt, listSiswa} = this.state;
        return (
            <div className="wrapper">
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title="Kecakapan Umum Siswa"/>
                    {this.loadAlert()}
                    <Row>  
                        <Col sm={6}>   
                            <Col style={{marginTop:'10px'}}><select className="form-control" name="kodeTahunAjaran" value={this.state.kodeTahunAjaran} onChange={this.handleOnChange} required>
                                    <option value="" selected disabled>~~ Pilih Tahun Ajaran ~~</option>
                                    <DropdownTahunAjaran tahunAjaran={this.state.ta} />
                                </select>
                            </Col> 
                            <Col style={{marginTop:'10px'}}><select className="form-control" name="idKelas" value={this.state.idKelas} onChange={this.handleOnChange} required>
                                    <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                    <DropdownKelas kelas={this.state.kelas} />
                                </select>
                            </Col>
                        </Col>
                        <Col sm={6}>
                            <Col style={{marginTop:'10px'}}><select className="form-control" name="idKelasParalel" value={this.state.idKelasParalel} onChange={this.handleOnChange} required>
                                    <option value="" selected disabled>~~ Pilih Kelas Paralel~~</option>
                                    <DropdownKelasParalel kelasParalel={this.state.kelasParalel} />
                                </select>
                            </Col>
                            <Col style={{marginTop:'10px'}}><select className="form-control" name="idJadwal" value={this.state.idJadwal} onChange={this.handleOnChange} required>
                                <option value="" selected disabled>~~ Pilih CBT ~~</option>
                                {jadwalCbt.map(jadwal => 
                                    <option value={jadwal.idJadwalCbt}>{jadwal.namaJadwalCbt}</option>
                                )}
                                </select>
                            </Col> 
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{margin :'18px', textAlign: 'right'}}><i>NB. Pastikan anda sudah pernah me-Generate <a href="javascript:void()" onClick={() => this.props.tutupReport()} style={{color :'red'}}><b>"Report Peminatan"</b></a> </i></Col>
                    </Row>
                    <Row>
                        <Col>{this.loading()}</Col>
                    </Row>

                    {!__.isEmpty(listSiswa) && this.renderSiswa() }

                    <br />
                    <div id="btn_print">                        
                        <div className="fixed_button">
                            <button className="btn btn-outline-danger pull-left" title="Kembali" style={{marginLeft:'1em'}} onClick={() => this.props.tutupReport()}>
                                <li className="fa fa-arrow-left"></li>
                            </button>
                        </div>     
                    </div>
                </div>
            </div> 
        );
    }


    loading = () =>{
        if(this.state.isLoading) {
            return(
                <Loader />
            )
        }
    }
    
    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
            return (
                <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        } 
    }
}
 
const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(KecakapanUmum);